import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const readUser = () => JSON.parse(localStorage.getItem('user') || '{}');

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(readUser);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const refreshUser = () => setUser(readUser());
    window.addEventListener('user-updated', refreshUser);
    window.addEventListener('storage', refreshUser);
    return () => {
      window.removeEventListener('user-updated', refreshUser);
      window.removeEventListener('storage', refreshUser);
    };
  }, []);

  useEffect(() => {
    setUser(readUser());
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  if (!token || location.pathname === '/login' || location.pathname === '/register') {
    return null;
  }

  return (
    <nav className="nav-header">
      <div className="nav-content">
        <Link to="/tasks" className="nav-logo">
          Lake Bennett Estate
        </Link>
        <div className="nav-links">
          <Link
            to="/tasks"
            className={`nav-link ${location.pathname.startsWith('/tasks') ? 'active' : ''}`}
          >
            Tasks
          </Link>
          {user.isAdmin && (
            <Link
              to="/admin"
              className={`nav-link ${location.pathname.startsWith('/admin') ? 'active' : ''}`}
            >
              Admin
            </Link>
          )}
          <Link
            to="/account"
            className={`nav-link ${location.pathname.startsWith('/account') ? 'active' : ''}`}
          >
            Account
          </Link>
          <div className="nav-user">
            <span className="nav-user-info">{user.username}</span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
